var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import 'react';
import styled, { css } from 'styled-components';
import { fromSize } from '../../utilities/media';
var appearance = function (_a) {
  var background = _a.background,
    color = _a.color,
    border = _a.border,
    hover = _a.hover,
    disabled = _a.disabled;
  return "\n  background-color: ".concat(background, ";\n  color: ").concat(color, ";\n  border: solid 2px ").concat(border ? border : background, ";\n\n  &:hover:not(:disabled) {\n    background-color: ").concat(hover.background, ";\n    ").concat(hover.color ? "color: ".concat(hover.color, ";") : '', "\n    ").concat(hover.borderColor ? "border-color: ".concat(hover.borderColor, ";") : '', "\n  }\n\n  &:disabled {\n    background-color: ").concat(disabled.background, ";\n    ").concat(disabled.color ? "color: ".concat(disabled.color, ";") : '', "\n    ").concat(disabled.borderColor ? "border-color: ".concat(disabled.borderColor, ";") : '', "\n    cursor: default;\n  }\n");
};
var overlayAppearance = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ::before {\n    content: '';\n    cursor: inherit;\n    display: block;\n    position: absolute;\n    inset: 0;\n  }\n"], ["\n  ::before {\n    content: '';\n    cursor: inherit;\n    display: block;\n    position: absolute;\n    inset: 0;\n  }\n"])));
export var StyledButton = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  width: 100%;\n  text-align: center;\n  margin: 0;\n  padding: ", ";\n  ", "\n  ", "\n  line-height: 20px;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: ", ";\n  border-radius: 4px;\n  cursor: pointer;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: ", ";\n"], ["\n  ", "\n\n  width: 100%;\n  text-align: center;\n  margin: 0;\n  padding: ", ";\n  ", "\n  ", "\n  line-height: 20px;\n  font-family: ", ";\n  font-weight: bold;\n  font-size: ", ";\n  border-radius: 4px;\n  cursor: pointer;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: ", ";\n"])), function (_a) {
  var overlay = _a.overlay;
  return overlay && overlayAppearance;
}, function (_a) {
  var size = _a.size;
  switch (size) {
    case 'large':
      return '18px 32px';
    case 'small':
      return '10px 16px';
    case 'extraSmall':
      return '6px 8px';
    case 'normal':
    default:
      return '14px 24px';
  }
}, function (_a) {
  var fullWidth = _a.fullWidth;
  return fullWidth ? '' : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          ", " {\n            width: auto;\n            max-width: ", ";\n          }\n        "], ["\n          ", " {\n            width: auto;\n            max-width: ", ";\n          }\n        "])), fromSize('md'), function (_a) {
    var size = _a.size;
    switch (size) {
      case 'large':
        return '400px';
      case 'small':
        return '280px';
      case 'extraSmall':
        return '240px';
      case 'normal':
      default:
        return '320px';
    }
  });
}, function (_a) {
  var color = _a["data-role"],
    inverted = _a.inverted,
    theme = _a.theme;
  switch (color) {
    case 'secondary':
      {
        return "\n            ".concat(inverted ? appearance({
          background: 'transparent',
          color: theme.tokens.text.label.reversed,
          border: theme.palette.white.main,
          hover: {
            background: "".concat(theme.palette.white.main, "1A")
          },
          disabled: {
            background: 'transparent',
            color: theme.tokens.accent.base.primary.light,
            borderColor: theme.tokens.accent.base.primary.light
          }
        }) : appearance({
          background: 'transparent',
          color: theme.tokens.accent.base.primary.regular,
          border: theme.tokens.accent.base.primary.regular,
          hover: {
            background: "".concat(theme.tokens.accent.base.primary.strong, "12"),
            color: theme.tokens.accent.base.primary.strong,
            borderColor: theme.tokens.accent.base.primary.strong
          },
          disabled: {
            background: 'transparent',
            color: theme.tokens.accent.base.primary.light,
            borderColor: theme.tokens.accent.base.primary.light
          }
        }), "\n          ");
      }
    case 'primary':
    default:
      {
        return "\n            ".concat(inverted ? appearance({
          background: theme.tokens.accent.token.primary.regular,
          color: theme.tokens.accent.onToken.primary.regular,
          hover: {
            background: theme.tokens.accent.token.primary.strong,
            color: theme.tokens.accent.onToken.primary.strong,
            borderColor: theme.tokens.accent.token.primary.strong
          },
          disabled: {
            background: theme.tokens.accent.token.primary.light,
            color: theme.tokens.accent.onToken.primary.light,
            borderColor: theme.tokens.accent.token.primary.light
          }
        }) : appearance({
          background: theme.tokens.accent.token.primary.regular,
          color: theme.tokens.accent.onToken.primary.regular,
          hover: {
            background: theme.tokens.accent.token.primary.strong,
            color: theme.tokens.accent.onToken.primary.strong,
            borderColor: theme.tokens.accent.token.primary.strong
          },
          disabled: {
            background: theme.tokens.accent.token.primary.light,
            color: theme.tokens.accent.onToken.primary.light,
            borderColor: theme.tokens.accent.token.primary.light
          }
        }), "\n          ");
      }
  }
}, function (_a) {
  var theme = _a.theme;
  return theme.typography.font.family.text;
}, function (_a) {
  var size = _a.size;
  switch (size) {
    case 'extraSmall':
      return '14px';
    case 'small':
    case 'large':
    case 'normal':
    default:
      return '16px';
  }
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xs;
});
export var UnstyledButton = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: unset;\n  border: unset;\n  padding: unset;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n  width: inherit;\n  max-width: 100%;\n  text-align: left;\n\n  ", "\n"], ["\n  background: unset;\n  border: unset;\n  padding: unset;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n  width: inherit;\n  max-width: 100%;\n  text-align: left;\n\n  ", "\n"])), function (_a) {
  var overlay = _a.overlay;
  return overlay && overlayAppearance;
});
export var OverlayWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var disableOverlay = _a.disableOverlay;
  return !disableOverlay && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      position: relative;\n      cursor: pointer;\n\n      a:not([data-overlay='true']),\n      button:not([data-overlay='true']) {\n        position: relative;\n        z-index: 1;\n      }\n    "], ["\n      position: relative;\n      cursor: pointer;\n\n      a:not([data-overlay='true']),\n      button:not([data-overlay='true']) {\n        position: relative;\n        z-index: 1;\n      }\n    "])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;